var map = {
	"./plain-sticker-A.png": 100,
	"./plain-sticker-B.png": 101,
	"./plain-sticker-C.png": 102,
	"./plain-sticker-D.png": 103,
	"./plain-sticker-E.png": 104,
	"./plain-sticker-F.png": 105,
	"./plain-sticker-G.png": 106,
	"./plain-sticker-H.png": 107,
	"./plain-sticker-I.png": 108,
	"./plain-sticker-J.png": 109,
	"./plain-sticker-K.png": 110,
	"./plain-sticker-L.png": 111,
	"./plain-sticker-M.png": 112,
	"./plain-sticker-N.png": 113,
	"./plain-sticker-O.png": 114,
	"./plain-sticker-P.png": 115,
	"./plain-sticker-Q.png": 116,
	"./plain-sticker-R.png": 117,
	"./plain-sticker-S.png": 118,
	"./plain-sticker-T.png": 119,
	"./plain-sticker-U.png": 120,
	"./plain-sticker-V.png": 121,
	"./plain-sticker-W.png": 122,
	"./plain-sticker-X.png": 123,
	"./plain-sticker-Y.png": 124,
	"./plain-sticker-Z.png": 125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 500;